
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
    name: 'Home',
    components: {},
    props: {},
    data() {
        return {
            completeUrl: false
        }
    },
    beforeMounted() {
        this.setCompleteUrl()
    },
    methods: {
        setCompleteUrl() {
            if (this.homePage?.url || this.homePage?.to) {
                this.completeUrl = this.homePage.url

                if (this.homePage.to) {
                    let to = this.homePage.to?.replaceAll('\\/', '/')

                    if (this.isFunctionality(to) || this.isADocument(to)) this.$router.push(to)
                    else this.completeUrl = process.env.VUE_APP_HOST_URL + this.homePage.to.replaceAll('\\/', '/')
                }
            } else {
                this.completeUrl = false
            }
        },
        isFunctionality(to: String): Boolean {
            return to.startsWith('/document-browser') || to.startsWith('/workspace')
        },
        isADocument(to: String): Boolean {
            return to.startsWith('/dossier/') || to.startsWith('/map/') || to.startsWith('/kpi/') || to.startsWith('/office-doc/') || to.startsWith('/document-composite/')
        }
    },
    computed: {
        ...mapState({
            homePage: 'homePage',
            user: 'user'
        })
    },
    watch: {
        homePage(oldHomePage, newHomePage) {
            if (oldHomePage !== newHomePage) this.setCompleteUrl()
        }
    }
})
